import { render, staticRenderFns } from "./LocaleVerify.vue?vue&type=template&id=7601ed1a&scoped=true"
import script from "./LocaleVerify.vue?vue&type=script&lang=js"
export * from "./LocaleVerify.vue?vue&type=script&lang=js"
import style0 from "./LocaleVerify.vue?vue&type=style&index=0&id=7601ed1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7601ed1a",
  null
  
)

export default component.exports